import React, { useEffect, useState } from "react";
import "./appointmentCustomTable.scss";
import { useNavigate, useLocation } from "react-router-dom";
import defaultProfilePicture from "../assets/logo/userAvatar.svg";
import Calendar from "./AvailabilityTable/Calendar";

import { Skeleton } from "antd";

import { api, appointmentApi, fetcher } from "../api";

import useSWR from "swr";
import { useSelector } from "react-redux";

// Dummy data for appointments
const dummyAppointments = [
    {
        id: 1,
        patient: { name: "John Baltimore" },
        provider: { name: "Dr. Smith" },
        startTime: "2024-08-27T10:00:00Z",
        endTime: "2024-08-27T12:00:00Z",
        status: "Pending",
    },
    {
        id: 2,
        patient: { name: "John Baltimore" },
        provider: { name: "Dr. Brown" },
        startTime: "2024-08-27T10:00:00Z",
        endTime: "2024-08-27T12:00:00Z",
        status: "Pending",
    },
    {
        id: 3,
        patient: { name: "John Baltimore" },
        provider: { name: "Dr. Wilson" },
        startTime: "2024-08-27T10:00:00Z",
        endTime: "2024-08-27T12:00:00Z",
        status: "Pending",
    },
    {
        id: 4,
        patient: { name: "John Baltimore" },
        provider: { name: "Dr. Garcia" },
        startTime: "2024-08-27T10:00:00Z",
        endTime: "2024-08-27T12:00:00Z",
        status: "Pending",
    },
    {
        id: 5,
        patient: { name: "John Baltimore" },
        provider: { name: "Dr. Martinez" },
        startTime: "2024-08-27T10:00:00Z",
        endTime: "2024-08-27T12:00:00Z",
        status: "Pending",
    },
    {
        id: 6,
        patient: { name: "John Baltimore" },
        provider: { name: "Dr. Taylor" },
        startTime: "2024-08-27T10:00:00Z",
        endTime: "2024-08-27T12:00:00Z",
        status: "Pending",
    },
    {
        id: 7,
        patient: { name: "John Baltimore" },
        provider: { name: "Dr. Lee" },
        startTime: "2024-08-27T10:00:00Z",
        endTime: "2024-08-27T12:00:00Z",
        status: "Pending",
    },
    {
        id: 8,
        patient: { name: "John Baltimore" },
        provider: { name: "Dr. White" },
        startTime: "2024-08-27T10:00:00Z",
        endTime: "2024-08-27T12:00:00Z",
        status: "Pending",
    },
    {
        id: 9,
        patient: { name: "John Baltimore" },
        provider: { name: "Dr. Davis" },
        startTime: "2024-08-27T10:00:00Z",
        endTime: "2024-08-27T12:00:00Z",
        status: "Pending",
    },
];

const AppointmentCustomTable = ({ refetch, setRefetch }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(30);
    const [appointments, setAppointments] = useState(dummyAppointments);
    const { user } = useSelector((state) => state.auth);

    const [loading, setLoading] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [showRescheduleModal, setShowRescheduleModal] = useState(false);
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    const initialTab =
        location.state?.tab || localStorage.getItem("activeTab") || "UPCOMING";

    const [activeTab, setActiveTab] = useState(initialTab);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const practiceId =
        user?.practice && user.practice.length > 0 ? user.practice[0].id : null;

    useEffect(() => {
        localStorage.setItem("activeTab", activeTab);
        // Simulate loading for demo purposes
        setLoading(true);
        setTimeout(() => {
            setAppointments(dummyAppointments);
            setLoading(false);
        }, 300);
    }, [currentPage, activeTab, practiceId, refetch]);

    const displayPageNumbers = () => {
        let pageNumbers = [];

        // Show pages 1, 2, 3, 4, ..., 30
        if (currentPage <= 4) {
            pageNumbers = [1, 2, 3, 4];
            if (totalPages > 4) {
                pageNumbers.push("...");
                pageNumbers.push(totalPages);
            }
        } else if (currentPage >= totalPages - 3) {
            pageNumbers = [1];
            if (totalPages > 4) {
                pageNumbers.push("...");
            }
            for (let i = Math.max(1, totalPages - 3); i <= totalPages; i++) {
                if (!pageNumbers.includes(i)) {
                    pageNumbers.push(i);
                }
            }
        } else {
            pageNumbers = [
                1,
                "...",
                currentPage - 1,
                currentPage,
                currentPage + 1,
                "...",
                totalPages,
            ];
        }

        return pageNumbers;
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleJoinSession = (appointment) => {
        console.log("Joining session for:", appointment);
    };

    const handleReschedule = (appointment) => {
        setSelectedAppointment(appointment);
        setShowRescheduleModal(true);
    };

    const handleCancelClick = (appointment) => {
        setSelectedAppointment(appointment);
        setShowCancelModal(true);
    };

    const handleCancelConfirm = () => {
        console.log("Cancelling appointment:", selectedAppointment);
        setAppointments((prev) =>
            prev.filter((apt) => apt.id !== selectedAppointment.id)
        );
        setShowCancelModal(false);
        setSelectedAppointment(null);
    };

    const handleModalClose = () => {
        setShowCancelModal(false);
        setSelectedAppointment(null);
    };

    const handleRescheduleModalClose = () => {
        setShowRescheduleModal(false);
        setSelectedAppointment(null);
    };

    const handleRescheduleConfirm = () => {
        console.log("Rescheduling appointment:", selectedAppointment);
        // Here you would typically call an API to reschedule the appointment
        setShowRescheduleModal(false);
        setSelectedAppointment(null);
    };

    return (
        <div className="appointments-container">
            <div className="appointments-content">
                <div className="appointments-tabs">
                    <div className="tab-items">
                        <span
                            onClick={() => setActiveTab("UPCOMING")}
                            className={
                                activeTab === "UPCOMING" ? "tab-active" : ""
                            }
                        >
                            Upcoming
                            <span className="tab-count">8</span>
                        </span>
                        <span
                            onClick={() => setActiveTab("COMPLETE")}
                            className={
                                activeTab === "COMPLETE" ? "tab-active" : ""
                            }
                        >
                            Complete
                        </span>
                    </div>
                </div>

                {loading ? (
                    <div className="loading-container">
                        {Array.from({ length: 5 }, (_, index) => (
                            <div className="skeleton-row" key={index}>
                                <Skeleton active paragraph={false} />
                            </div>
                        ))}
                    </div>
                ) : (
                    <>
                        <div className="appointments-table">
                            <div className="table-header">
                                <div
                                    className="header-cell date-column"
                                    style={{ paddingLeft: "40px" }}
                                >
                                    Date
                                </div>
                                <div
                                    className="header-cell patient-column"
                                    style={{ paddingLeft: "40px" }}
                                >
                                    Patient Name
                                </div>
                                <div className="header-cell time-column">
                                    Time
                                </div>
                                <div className="header-cell actions-column">
                                    Actions
                                </div>
                            </div>

                            <div className="table-body">
                                {Array.isArray(appointments) &&
                                    appointments.map((appointment, index) => (
                                        <div
                                            key={appointment?.id}
                                            className="table-row"
                                        >
                                            <div className="table-cell date-column">
                                                Aug 27th, 2024
                                            </div>
                                            <div className="table-cell patient-column">
                                                John Baltimore
                                            </div>
                                            <div
                                                className="table-cell time-column"
                                                style={{
                                                    marginLeft: "5px",
                                                    marginRight: "5px",
                                                }}
                                            >
                                                10:00am - 12:00pm
                                            </div>
                                            <div className="table-cell actions-column">
                                                {activeTab === "UPCOMING" && (
                                                    <div className="action-buttons">
                                                        <button
                                                            className="reschedule-btn "
                                                            onClick={() =>
                                                                handleReschedule(
                                                                    appointment
                                                                )
                                                            }
                                                        >
                                                            Reschedule
                                                        </button>
                                                        <button
                                                            className="cancel-btn"
                                                            onClick={() =>
                                                                handleCancelClick(
                                                                    appointment
                                                                )
                                                            }
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>

                        <div className="pagination-container">
                            <div className="pagination-info">
                                Page {currentPage} of {totalPages}
                            </div>

                            <div className="pagination-controls">
                                <button
                                    className={`pagination-btn ${
                                        currentPage === 1 ? "disabled" : ""
                                    }`}
                                    onClick={handlePrevPage}
                                    disabled={currentPage === 1}
                                >
                                    &lt; Previous
                                </button>

                                <div className="page-numbers">
                                    {displayPageNumbers().map(
                                        (pageNumber, index) =>
                                            pageNumber === "..." ? (
                                                <span
                                                    key={`ellipsis-${index}`}
                                                    className="ellipsis"
                                                >
                                                    ...
                                                </span>
                                            ) : (
                                                <button
                                                    key={pageNumber}
                                                    className={`page-number ${
                                                        pageNumber ===
                                                        currentPage
                                                            ? "active"
                                                            : ""
                                                    }`}
                                                    onClick={() =>
                                                        handlePageChange(
                                                            pageNumber
                                                        )
                                                    }
                                                >
                                                    {pageNumber}
                                                </button>
                                            )
                                    )}
                                </div>

                                <button
                                    className={`pagination-btn ${
                                        currentPage === totalPages
                                            ? "disabled"
                                            : ""
                                    }`}
                                    onClick={handleNextPage}
                                    disabled={currentPage === totalPages}
                                >
                                    Next &gt;
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div>
            {/* Cancel Appointment Modal"" */}
            {showCancelModal && (
                <div className="modal-overlay" onClick={handleModalClose}>
                    <div
                        className="cancel-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="modal-close-btn"
                            onClick={handleModalClose}
                        >
                            ×
                        </button>

                        <div className="modal-content">
                            <div className="cancel-icon">
                                <div className="cancel-icon-circle">×</div>
                            </div>

                            <h2 className="modal-title">Cancel Appointment</h2>
                            <p className="modal-description">
                                Appointment will be cancelled and removed
                                <br />
                                from calendar
                            </p>

                            <div className="modal-actions">
                                <button
                                    className="back-btn"
                                    onClick={handleModalClose}
                                >
                                    Back
                                </button>
                                <button
                                    className="proceed-btn"
                                    onClick={handleCancelConfirm}
                                >
                                    Proceed
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Reschedule Appointment Modal */}
            {showRescheduleModal && selectedAppointment && (
                <div
                    className="modal-overlay"
                    onClick={handleRescheduleModalClose}
                >
                    <div
                        className="reschedule-modal"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            maxWidth: "750px", // Maximum width for large screens
                            minWidth: "600px", // Minimum width to fit content
                            height: "auto", // Allow height to adjust
                            overflow: "visible", // Prevent unwanted scrollbars
                        }}
                    >
                        <button
                            className="modal-close-btn"
                            onClick={handleRescheduleModalClose}
                        >
                            ×
                        </button>

                        <div className="modal-content">
                            <div className="modal-header">
                                <p className="modal-main-title">
                                    Reschedule appointment
                                </p>
                                {/* <p>
                                    Select preferred date and time to see this
                                    provider.
                                </p> */}
                            </div>

                            <div className="provider-info">
                                <div className="provider-avatar">
                                    <span className="avatar-initials">AL</span>
                                </div>
                                <div
                                    className="provider-details"
                                    style={{ margingTop: "20px" }}
                                >
                                    <h3 className="provider-name">
                                        Ada Lovelace
                                    </h3>
                                    <p className="provider-title">
                                        PSYCHOLOGIST
                                    </p>
                                </div>
                            </div>

                            <div className="reschedule-content">
                                <div className="calendar-section">
                                    <Calendar
                                        selectedDate={selectedDate}
                                        onDateSelect={(date) =>
                                            setSelectedDate(date)
                                        }
                                    />
                                </div>

                                <div
                                    className="time-slots-section"
                                    style={{ border: " 1px solid #e2e8f0;" }}
                                >
                                    <div className="time-slot selected">
                                        8:00am-8:15am
                                    </div>
                                    <div className="time-slot">
                                        10:00am-10:15am
                                    </div>
                                    <div className="time-slot">
                                        12:00pm-12:15pm
                                    </div>
                                    <div className="time-slot">
                                        1:00 pm- 1:15pm
                                    </div>
                                    <div className="time-slot">
                                        12:00pm-12:15pm
                                    </div>
                                    <div className="time-slot">
                                        1:00 pm- 1:15pm
                                    </div>
                                </div>
                            </div>

                            <div className="modal-actions">
                                <button
                                    className="cancel-btn"
                                    onClick={handleRescheduleModalClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="next-btn"
                                    onClick={handleRescheduleConfirm}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="footer-text">© 2024 CARE PLAN 365</div>
        </div>
    );
};

export default AppointmentCustomTable;
